import styled from "styled-components";

export const CMlogo = styled.div((props) => ({
    display: 'flex',
    placeContent: "center",
  "& .title": {
    width:"100%",
    "@media (max-width:580px)": {
      marginLeft: "1.3rem",
      marginRight: "1.3rem",
    },
  },
  "& > div > img": {
    "@media (max-width:860px)": {},
  },
  "& > div > h2": {
    fontSize: "clamp(1rem,1vw + 1rem,2rem)",
  },
}));

export const CMLabel = styled.div((props) => ({
  "& .labelTotalUnit": {
    "@media (max-width:320px)": {
      marginLeft: "1rem",
    },
  },
}));

export const CMContainer = styled.div((props) => ({
  "& > .container": {
    "@media (max-width:580px)": {
      marginLeft: "1.3rem",
      marginRight: "1.3rem",
    },
    "& > .button-container": {
      marginRight: "0",
    },
  },
}));

export const CMButton = styled.div((props) => ({
    "& .button-container": {
        display: 'flex',
    placeContent: 'center'
    },
  "& > .button-container button": {
      marginRight: "0"
  },
}));
